<script setup lang="ts">
const props = defineProps<{
  color: string;
}>();
</script>

<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 4H20C21.103 4 22 4.897 22 6V18C22 19.103 21.103 20 20 20H6L2 24V6C2 4.897 2.897 4 4 4Z"
      :fill="color"
    />
    <circle cx="21.5" cy="4.5" r="2.5" fill="#BC3493" />
  </svg>
</template>
